import instance from "../components/general/AxiosInterceptor";

export const getConsultationSouscriptionsListApi = (data) => {
  return instance.post("/souscriptions/search", data);
};

export const getDetailsSouscriptionsApi = (data) => {
  return instance.get(`/souscriptions/detail?idSouscription=${data}`);
};

export const getHistorySouscriptionsApi = (data) => {
  return instance.get(`/souscriptions/history?idSouscription=${data}`);
};



export const getSouscriptionSituationApi = (data) => {
  return instance.get(`/souscriptions/history?idSouscription=${data.idRole}&${data.idUser}`);
};


export const modificationSouscriptionApi = ({ souscriptionId, data }) => {
  return instance.patch(`/souscriptions/update/${souscriptionId}`, data);
};

export const getSouscriptionApi = (souscriptionId) => {
  return instance.get(`/souscriptions/${souscriptionId}`);
};

export const createNouvelleSouscriptionApi = (data) => {
  return instance.post(
    `/souscriptions/souscrire?idPackage=${data?.packageId}&exercice=${
      data?.values?.exercice
    }&user=${data?.user == null ? "" : data?.user}`
  );
};

export const excelExportSouscriptionsApi = (data) => {
  return instance.post("/souscriptions/exporter", data);
};

export const generationBonCommandeSouscriptionsApi = (id) => {
  return instance.get(`/souscriptions/genererBonCommande?idSouscription=${id}`);
};

export const confirmerPaiementSouscriptionApi = (data) => {
  return instance.post(`/souscriptions/confirmerPaiement`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const getFactureSouscriptionApi = (idSouscription) => {
  return instance.get(`/paiement/factures/${idSouscription}`);
};

export const paiementSouscriptionApi = (data) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ data: { body: true } });
    }, 2000);
  });
};

export const existForfaitAvecMemeExerciceApi = (data) => {
  return instance.get(`/souscriptions/existForfait?exercice=${data}`);
};


export const tracePaymentInAccountApi = (data) => {
  console.log("tracePaymentInAccountApi", data);
  return instance.post(`/paiement/trace-transaction`, data);
};